// extracted by mini-css-extract-plugin
export var alertIcon = "_pc-0";